import { Component, OnInit, Output, ViewChild, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { MatTableDataSource, MatPaginator, MatSnackBar, MatDialogConfig } from '@angular/material';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogboxComponent } from '../../../public/dialogbox/dialogbox.component';
import { SponserService } from 'src/app/shared/services/sponser.service';
import { AppSettings } from '../../../app.constant';

import { User } from '../../../shared/interface/user';
import { Observable } from 'rxjs';
import { DataSource } from '@angular/cdk/table';

@Component({
  selector: 'app-sponser-table',
  templateUrl: './sponser-table.component.html',
  styleUrls: ['./sponser-table.component.css']
})

export class SponserTableComponent implements OnInit {
  fileNameDialogRef: MatDialogRef<DialogboxComponent>;
  displayedColumns: string[] = ['SponserCode', 'SponserName', 'Address', 'Edit'];
  httpResponseMessage: any;
  post: any;
  resultdata: any;
  dataSource: any;
  Sponser: any;
  errorMessage: any;
  status: any;
  progressBar: boolean = true;

  @Output() messageEvent = new EventEmitter<string>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(
    private _sponserservice: SponserService,
    private changeDetectorRefs: ChangeDetectorRef,
    private snackBar: MatSnackBar,
    public dialog: MatDialog, ) { }

  ngOnInit() {
    this._sponserservice.refreshNeeded$
      .subscribe(() => {
        this.getallsponser();
      })
    this.getallsponser();
  }

  getallsponser() {
    this._sponserservice.getAllSponsers(AppSettings.API_ENDPOINT + AppSettings.GetAllSponser)
      .subscribe(result => {
        this.resultdata = result;
        this.progressBar = false;
        if (!result) {
          return;
        }
        this.dataSource = new MatTableDataSource(this.resultdata);
        this.dataSource.paginator = this.paginator;
      });
  }

  onEditSponser(param: any): void {
    var o = { PK_SponserID: param.PK_SponserID }
    this.post = JSON.stringify(o);
    this._sponserservice.getSponserByID(AppSettings.API_ENDPOINT + AppSettings.GetSponserByID, this.post).subscribe(
      data => {
        this.Sponser = data;
        this.messageEvent.emit(this.Sponser);
      },
      error => this.errorMessage = <any>error)
  }

  onDeleteSponser(param: any): void {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title: "Sponser",
      data: param.SponserName
    };

    this.fileNameDialogRef = this.dialog.open(DialogboxComponent, dialogConfig);
    this.fileNameDialogRef.afterClosed().subscribe(result => {
      this.status = result;
      if (this.status == "ok") {
        var o = { PK_SponserID: param.PK_SponserID }
        this.post = JSON.stringify(o);
        this._sponserservice.deleteSponserByID(AppSettings.API_ENDPOINT + AppSettings.DeleteSponser, this.post).subscribe(
          data => {
            this.httpResponseMessage = data
            this.openSnackBar(this.httpResponseMessage, '');
          },
          error => this.errorMessage = <any>error)
      }
    });
  }

  durationInSeconds = 2;
  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 2000,
      verticalPosition: 'bottom'
    });
  }
}